import SectionTitle from "./SectionTitle";

const FEATURED = {
  title: "一组流出的环境实拍，把现场方位补了个大半",
  desc: "多张实拍从不同街口取景，光线与地标对应上之后，画面里的先后关系好判断了许多。",
  tag: "实拍图证",
  meta: "已归档 12 张 · 时间戳核对 9 张",
};

const GRID = [
  {
    title: "正面机位之外的侧向视角，刚刚对上",
    tag: "图片流出",
    meta: "流出 6 张",
    img: "https://readdy.ai/api/search-image?query=abstract%20editorial%20photo%20of%20warm%20aged%20paper%20stack%20with%20soft%20layered%20shadows%20and%20a%20single%20vermilion%20red%20accent%20card%20tucked%20between%2C%20studio%20lighting%2C%20cream%20beige%20neutral%20palette%2C%20archival%20document%20feeling%2C%20quiet%20minimalist%20composition%2C%20high%20key&width=1200&height=760&seq=docs-grid-911-b2&orientation=landscape"
  },
  {
    title: "聊天截图里的一串时间戳，改变了判断",
    tag: "截图线索",
    meta: "线索 4 条",
    img: "https://readdy.ai/api/search-image?query=minimal%20editorial%20still%20life%20of%20a%20smartphone%20lying%20flat%20on%20warm%20linen%20textile%20with%20soft%20reflected%20red%20light%2C%20muted%20cream%20and%20stone%20tones%2C%20soft%20shadows%2C%20archival%20document%20mood%2C%20cinematic%20gentle%20lighting%2C%20quiet%20negative%20space%2C%20editorial%20photography&width=1200&height=760&seq=docs-grid-911-c3&orientation=landscape"
  },
];

export default function Docs() {
  return (
    <section id="docs" className="scroll-mt-20 bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <SectionTitle
          index="02"
          kicker="影像图证"
          title={<>图片流出怎么核对？先看这几张大图</>}
          lead="现场视频之外的静态材料，统一走“大图+说明”的方式陈列：哪张补了什么信息、能不能对上时间线，直接标在图卡上。"
        />

        <a
          href="#discuss"
          className="group grid grid-cols-1 overflow-hidden rounded-lg border border-foreground-200/70 bg-background-100 lg:grid-cols-2"
        >
          <div className="relative overflow-hidden lg:h-full">
            <img
              src="https://readdy.ai/api/search-image?query=broad%20abstract%20editorial%20backdrop%20of%20overlapping%20warm%20translucent%20paper%20sections%20with%20a%20bold%20vermilion%20red%20geometric%20stripe%20and%20subtle%20grid%20lines%2C%20cream%20ivory%20stone%20tonal%20palette%2C%20magazine%20spread%20negative%20space%2C%20soft%20diffused%20studio%20light%2C%20clean%20minimal%20graphic%20editorial%20style%2C%20high%20detail&width=1400&height=900&seq=docs-feature-911-d4&orientation=landscape"
              alt="实拍图证主打素材示例"
              title="911网实拍图证 · 环境实拍归档"
              className="h-64 w-full object-cover object-top lg:h-full"
            />
            <span className="absolute left-3 top-3 rounded-full bg-background-50/90 px-3 py-1 text-[11px] text-primary-700 backdrop-blur">
              {FEATURED.tag}
            </span>
          </div>
          <div className="flex flex-col justify-center p-6 md:p-10">
            <p className="text-[12px] tracking-wide text-foreground-400">主打大图 · 今日归档</p>
            <h3 className="mt-3 font-serif text-xl font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600 md:text-2xl">
              {FEATURED.title}
            </h3>
            <p className="mt-3 text-sm leading-6 text-foreground-500">{FEATURED.desc}</p>
            <div className="mt-5 flex flex-wrap items-center gap-3 text-[12px] text-foreground-400">
              <span className="inline-flex items-center gap-1.5">
                <i className="ri-stack-line text-[13px]" aria-hidden="true" />{FEATURED.meta}
              </span>
              <span className="inline-flex items-center gap-1 text-primary-600">
                查看对表 <i className="ri-arrow-right-line text-[13px]" aria-hidden="true" />
              </span>
            </div>
          </div>
        </a>

        <div className="mt-6 grid grid-cols-1 gap-6 md:grid-cols-2">
          {GRID.map((c) => (
            <a
              key={c.title}
              href="#index"
              className="group overflow-hidden rounded-lg border border-foreground-200/70 bg-background-100"
            >
              <div className="relative overflow-hidden">
                <img
                  src={c.img}
                  alt={`${c.title}素材示意`}
                  title={`911网图片流出 · ${c.title}`}
                  className="h-56 w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.03]"
                />
                <span className="absolute left-3 top-3 rounded-full bg-background-50/90 px-3 py-1 text-[11px] text-accent-700 backdrop-blur">
                  {c.tag}
                </span>
              </div>
              <div className="p-5 md:p-6">
                <h3 className="font-serif text-[17px] font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600">
                  {c.title}
                </h3>
                <p className="mt-2 flex items-center gap-1.5 text-[12px] text-foreground-400">
                  <i className="ri-folder-2-line text-[13px]" aria-hidden="true" />{c.meta}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}